import { render, staticRenderFns } from "./HoroscopeTop.vue?vue&type=template&id=9a98a4dc"
import script from "./HoroscopeTop.vue?vue&type=script&lang=js"
export * from "./HoroscopeTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports